import { render, staticRenderFns } from "./bulkUpdate.vue?vue&type=template&id=39791695&scoped=true&"
import script from "./bulkUpdate.vue?vue&type=script&lang=js&"
export * from "./bulkUpdate.vue?vue&type=script&lang=js&"
import style0 from "./bulkUpdate.vue?vue&type=style&index=0&id=39791695&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39791695",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VCol,VImg,VRow,VSimpleTable})
